import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import { type PartnerEventStatusCounts } from '@/api/routes/partners/partners.events.api';
import { type EventsTab } from '@/domain/events/types';
import { EVENTS_TABS, eventsTabLabel } from '@/domain/events/utils';

interface Props {
  value: EventsTab;
  counts?: PartnerEventStatusCounts;
  onChange: (tab: EventsTab) => void;
}

/** One tab per status, with its count (P08). A zero shows as "0", never as a dash. */
const EventsStatusTabs = ({ value, counts, onChange }: Props) => (
  <Tabs
    value={value}
    onChange={(_, tab: EventsTab) => onChange(tab)}
    variant="scrollable"
    scrollButtons="auto"
    allowScrollButtonsMobile
  >
    {EVENTS_TABS.map((tab) => (
      <Tab
        key={tab}
        value={tab}
        label={counts ? `${eventsTabLabel[tab]} (${counts[tab]})` : eventsTabLabel[tab]}
      />
    ))}
  </Tabs>
);

export default EventsStatusTabs;
